import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useMeta } from "@/lib/site";
import { FragranceCard } from "@/components/FragranceCard";
import { Overline, Reveal } from "@/components/Reveal";

const filters = ["All", "Women", "Men", "Unisex"];

export default function Collection() {
  useMeta("The Collection", "Nine fragrances. One signature. Explore the complete Bonheur Eternal collection — Women, Men and Unisex eaux de parfum, delivered all over Pakistan.");
  const [filter, setFilter] = useState("All");
  const { data: fragrances = [] } = useQuery({
    queryKey: ["fragrances"],
    queryFn: async () => (await api.get("/fragrances")).data,
  });
  const shown = filter === "All" ? fragrances : fragrances.filter((f) => f.gender === filter);

  return (
    <div className="pt-32 md:pt-44 pb-32 px-5 md:px-8 max-w-7xl mx-auto">
      <Reveal>
        <Overline>The Collection</Overline>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2B2118] mt-4 tracking-tight max-w-3xl">
          Nine compositions.<br />
          <span className="italic text-[#8F6B3A]">One signature.</span>
        </h1>
      </Reveal>
      <div className="flex flex-wrap items-center justify-between gap-6 mt-14 mb-16 border-b border-[#2B2118]/[0.06] pb-4">
        <div className="flex gap-6">
          {filters.map((fl) => (
            <button
              key={fl}
              data-testid={`filter-${fl.toLowerCase()}`}
              onClick={() => setFilter(fl)}
              className={`text-[12px] tracking-[0.2em] uppercase pb-1 border-b font-medium transition-colors duration-300 ${
                filter === fl ? "text-[#6F5433] border-[#6F5433] font-semibold" : "text-[#5C4A33] border-transparent hover:text-[#2B2118]"
              }`}
            >
              {fl}
            </button>
          ))}
        </div>
        <Link to="/scent-finder" data-testid="collection-scent-finder-link" className="text-[12px] tracking-[0.2em] uppercase font-medium text-[#6F5433] hover:text-[#2B2118] transition-colors">
          Not sure? Try the Scent Finder →
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-testid="collection-grid">
        {shown.map((f, i) => (
          <FragranceCard key={f.slug} f={f} index={i} />
        ))}
      </div>
    </div>
  );
}
